import Campaign from "./campaign";
import Entity from "./entity";
import GameMap from "./map";

export default class Universe {
    id!: string ;
    visible = true;
    name = '';
    description = '';
    entities: Entity[] = [];
    maps: GameMap[] = [];
    campaigns: Campaign[] = [];


    constructor(data?: any) {
        if (data) {
            if (typeof data !== "object") data = JSON.parse(data);
            Object.assign(this, data);
        }

        this.entities = (this.entities ?? []).map((entity) => new Entity(entity));
        this.maps = (this.maps ?? []).map((map) => new GameMap(map));
        this.campaigns = (this.campaigns ?? []).map((campaign) => new Campaign(campaign));
    }
}
